import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {MaterialDeclaration, DeclarationState} from "@/modules/material_declaration/types";
import {saveMaterialDeclaration, saveMaterialDeclarations} from "@/services/material_declaration";

export const state: DeclarationState = {
  materialDeclaration: {
    id: 0,
    id_agreement: 0,
    id_purchase: 0,
    id_agreement_group: 0,
    product_specific_rule: "",
    id_supplier: 0,
    originating: false,
    regional_value_content: 0,
    start_application_date: new Date(),
    end_application_date: new Date(),
  }
}

const actions: ActionTree<DeclarationState, RootState> = {
  async SAVE_MATERIAL_DECLARATION(_, materialDeclaration: MaterialDeclaration) {
    return await saveMaterialDeclaration(materialDeclaration);
  },
  async SAVE_MATERIAL_DECLARATIONS(_, materialDeclarations: MaterialDeclaration[]) {
    return await saveMaterialDeclarations(materialDeclarations);
  },
}

const mutations: MutationTree<DeclarationState> = {
}

const getters: GetterTree<DeclarationState, RootState> = {
}

export const material_declaration: Module<DeclarationState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
